const workBookState = {
  name: 'test',
  workbookQueryBoxData: [],
  updatedMode: '',
}

const workbookReducer = (state = workBookState, action) => {
  if (action.type === 'CHANGE_NAME') {
    return { ...state, name: action.payload }
  }
  if (action.type === 'CHANGE_QUERYBOXARRAY') {
    return { ...state, workbookQueryBoxData: action.payload }
  }
  if (action.type === 'CHANGE_MODE') {
    //console.log(action)
    return { ...state, updatedMode: action.payload.QueryString }
  }
  return { ...state }
}

export default workbookReducer
